<template>
  <div id="app" :class="{'dom-loaded': domLoaded}">
    <header class="header">
      <nav class="container">
        <div class="row">
          <div class="col-sm-3 col-3 divlogo">
            <a :href="gethomelink()" class="header__logo">
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 281 40">
                <path fill="#D92128" d="M222.5 13h48.6c5.2 0 9.5 4.3 9.5 9.5s-4.3 9.5-9.5 9.5h-48.6c-5.2 0-9.5-4.3-9.5-9.5s4.3-9.5 9.5-9.5z"></path><path fill="#FFF" d="M233.4 21.6c0 1.4-.6 3.3-1.6 4.2-.8.8-1.7 1.1-3.2 1.1h-2.1l1.8-8.3h1.8c1.3 0 2.1.1 2.6.7.4.6.7 1.3.7 2.3zm-1.5.1c0-.5-.1-.9-.3-1.3-.3-.4-.7-.6-1.4-.6h-.9l-1.3 6.1h.9c.9 0 1.5-.3 1.9-.9.8-1.1 1.1-2.7 1.1-3.3zm6.3-3h-1.4L235 27h1.4l1.8-8.3zm7.8 1.9c0 1.6-1.1 2.6-2.5 2.8h-.1c.3.2.5.6.8 1.1.3.6.9 2.3 1 2.5l-1.5.1c-.1-.2-.4-1.2-.5-1.4-.5-1.2-.8-1.6-1-2-.2-.2-.3-.2-.5-.2l-.8 3.6h-1.4l1.8-8.3h2.5c1.4-.1 2.2.6 2.2 1.8zm-1.5.2c0-.7-.4-1-1.3-1h-.9l-.6 2.6h.7c.7 0 1.1-.1 1.4-.3.4-.3.7-.8.7-1.3zm9.1-2.1H249l-1.8 8.3h4.8l.3-1.2H249l.5-2.6h2.6l.2-1.1h-2.6l.5-2.3h3.1l.3-1.1zm7.3.5c-.4-.4-1.1-.7-1.9-.7-1.2 0-2.5.6-3.3 1.6-.9 1.1-1.4 2.7-1.4 4 0 1.8 1 3 2.8 3 .9 0 1.7-.2 2.5-.7l-.5-.9c-.6.4-1.1.6-1.6.6-1.1 0-1.7-.6-1.7-1.8 0-1 .4-2.7 1.1-3.6.5-.6 1.2-1 1.9-1 .5 0 1 .1 1.3.5l.8-1zm7.5-.5h-5.8l-.2 1.1h2.1L263 27h1.4l1.5-7.2h2.1l.4-1.1z"></path><path fill="#FFD400" d="M18.9 32.5c-8.1-.8-15.3-4.7-18-9.2.1.8 1.1 2.7 1.5 3.9.3.9.8 1.6 1 2.3 3.4 2.4 7.2 3.6 12.5 4.1 5.5.5 10.3-.1 14.1-2-3.3.9-7 1.3-11.1.9M12.5 16.1C9.7 13 7.2 10 5 7c-.3.4-.6.8-1 1.3-.4.7-.8 1.4-1.1 1.9 2.1 2.3 4.5 4.7 7.1 7 7.3 6.6 14.5 10.9 20.2 14-5.2-3.7-11.4-8.3-17.7-15.1M24.1 10.7C22 6.5 20.4 3.8 17.9.5c-.3 0-.8.3-1.8.4-.7.1-1.4 0-2 .3 3.5 3.7 6.3 7.6 9.5 13.1 3.5 6.3 5.3 11.4 6.8 16.6-.5-6-2.4-12.3-6.3-20.2"></path><path fill="#005A9D" d="M20.7 38.92c-10.2 0-18.4-8-18.4-17.8s8.2-17.5 18.3-17.5c10 0 18.1 7.4 18.4 17v-.7C39.1 9.02 30.3.32 19.5.32S0 9.02 0 19.82c0 10.7 8.7 19.4 19.5 19.4 2.1 0 4.1-.3 6-.9-1.5.4-3.1.6-4.8.6"></path><path fill="#B51E82" d="M10.1 11.6c7-7.1 17.8-7.6 24.2-1.2 3.9 3.9 5.5 9.9 4.1 15 1.8-6.1.7-12.9-3.9-17.6-6.7-6.8-18-6.4-25 .7-4.6 4.7-6.2 11.2-4.9 17-.2-4.9 1.7-10 5.5-13.9"></path><path fill="#009065" d="M38.1 21.5c-.1-4.3-1.7-8.2-4.7-10.3-5.8-4-14.8-.9-20.5 7.4-2.9 4.3-4.3 9-4.1 13.1-1.3-4.8-.2-10.8 3.3-16 5.6-8.2 15.4-11.3 21.8-6.9 3.8 2.6 5.6 7.3 5.3 12.4 0 0-.1 1.5-.3 2.1-.1.6-.5 1.9-.6 2.3-.1.4-.2-4.1-.2-4.1"></path><path fill="#F26F21" d="M18.8 19c-5.7 6.1-7 14.2-2.9 18.1.2.2.4.3.6.5-3.7-3.6-2.6-10.6 2.5-16 4.6-5 12.5-7.2 16.3-3.6 3.4 3.2 2.9 9.3-.8 14.4 5.1-6 6.1-13.6 2.2-17.3-4.2-3.9-12.2-2.1-17.9 3.9"></path><path fill="#DA2027" d="M24.2 25.3c-3.9 3.4-5.2 8.2-2.9 10.8 1.8 2 5.2 2.1 8.5.4-2.7 1.3-5.6 1.1-7.1-.6-2-2.3-.9-6.6 2.5-9.5 3.4-2.9 7.7-3.4 9.7-1.1 1.5 1.7 1.3 4.6-.4 7.1 2.1-3 2.5-6.4.7-8.5-2.2-2.6-7.2-2-11 1.4M59.5 16.1h-2.2l-1.3 6h2.3c1.4 0 2.1-.3 2.7-.9.8-.8 1.2-1.9 1.2-2.9-.1-1.4-.8-2.2-2.7-2.2m2.9 7.2c-1.5.9-2.7 1.2-4.5 1.2h-2.4l-1.4 6.6h-2.9l3.7-17.3h4.5c2.1 0 3.4.3 4.3.9 1 .7 1.6 1.8 1.6 3.1-.1 2.5-1.2 4.4-2.9 5.5M72.3 22.1c-.2-.1-.4-.2-.8-.2-.8 0-1.6.6-2.6 2l-1.5 7.2H65l1.6-7.5c.3-1.5.3-2.4.1-3.1l2.3-.9c.2.6.3 1.4.2 2.2 1-1.3 2.3-2.1 3.3-2.1.4 0 .6 0 .9.2l-1.1 2.2zM78.3 21.5c-2.2 0-3.4 3.5-3.4 6.1 0 1.4.6 1.9 1.7 1.9 2.2 0 3.3-3.3 3.3-6 .1-1.5-.6-2-1.6-2m-2 9.8c-2.5 0-3.9-1.4-3.9-4 0-4.3 2.6-7.7 6.3-7.7 2.6 0 4 1.5 4 3.9 0 4.2-2.3 7.8-6.4 7.8M96.7 16.7c-.8-.7-1.7-1-2.8-1-1.5 0-2.9.8-4 2.2-1.4 1.8-2.3 5.3-2.3 7.4 0 2.5 1.3 3.8 3.5 3.8 1.2 0 2.1-.4 3.4-1.2l1 1.9c-1.6 1.1-3.3 1.6-5.2 1.6-3.7 0-5.9-2.3-5.9-6.2 0-2.8 1.1-6.1 2.8-8.3 1.8-2.2 4.4-3.4 6.9-3.4 1.7 0 3.2.5 4 1.4l-1.4 1.8zM104.6 22.1c-.2-.1-.4-.2-.8-.2-.8 0-1.6.6-2.6 2l-1.5 7.2h-2.4l1.6-7.5c.3-1.5.3-2.4.1-3.1l2.3-.9c.2.6.3 1.4.2 2.2 1-1.3 2.3-2.1 3.3-2.1.4 0 .6 0 .9.2l-1.1 2.2zM110.6 21.4c-1.3 0-2.4 1-2.9 3.1.1 0 .6.1 1 .1 1.3 0 2.3-.2 2.8-.7.3-.3.5-.6.5-1.1 0-.8-.4-1.4-1.4-1.4m2.8 3.5c-.9.9-2.5 1.4-4.7 1.4-.6 0-1.1-.1-1.3-.1 0 .2-.1.8-.1 1.2 0 1.4.8 2.1 2 2.1s2.1-.4 3.2-1.2l.8 1.5c-1.3 1.1-2.7 1.6-4.6 1.6-2.4 0-4-1.4-4-4.1 0-2.2 1-4.6 2.5-6.1 1.1-1.1 2.3-1.5 3.8-1.5 2.2 0 3.5 1 3.5 3-.1.8-.4 1.6-1.1 2.2M121.8 21.7c-.7 0-1.5.4-2 1-.9 1.1-1.5 3.3-1.5 4.8 0 1.2.4 1.9 1.3 1.9s2.1-.8 2.8-2l1.1-5.2c-.4-.4-.9-.5-1.7-.5zm3.1 5.5c-.5 2.4-.4 3.1-.1 3.6l-2.1.5c-.3-.4-.5-.9-.4-1.6-.9 1.1-2 1.6-3.3 1.6-2.2 0-3.3-1.3-3.3-3.9 0-2.2.9-4.6 2.5-6.2 1.1-1 2.5-1.6 3.7-1.6 1 0 1.8.2 2.1.4 0-.1.2-1.1.3-1.5l.8-3.8 2.3.4-2.5 12.1zM131.7 18.3c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6 0 .8-.7 1.6-1.6 1.6zm-1.8 12.8h-2.5l2.3-11.1 2.5-.4-2.3 11.5zM139.6 21.6h-2.1l-1.3 6c-.1.4-.1.8-.1 1.1 0 .7.3.9 1 .9.4 0 .8-.1 1.1-.2v1.5c-.8.3-1.5.5-2.3.5-1.5 0-2.3-.8-2.3-1.9 0-.4 0-1 .2-1.5l1.3-6.4h-1.3l.4-1.7h1.3c.2-1 .4-1.9.7-2.7l2.6-.6c-.3 1-.7 2.3-.9 3.3h2.7l-1 1.7zM153.7 16.2h-2.4l-1 4.7h2.5c1.1 0 1.7-.2 2.2-.6.6-.5 1.1-1.3 1.1-2.2 0-1.3-.6-1.9-2.4-1.9m-1.3 7.1h-2.6l-1.2 5.4h2.8c1 0 1.8-.3 2.4-.7.8-.5 1.3-1.6 1.3-2.7 0-1.3-.7-2-2.7-2m3.1-1.4c1.8.4 2.8 1.8 2.8 3.5 0 1.3-.6 2.9-1.9 4-1.3 1.2-2.7 1.7-5.6 1.7h-5.5l3.7-17.3h5.4c3.3 0 4.9 1.4 4.9 3.8 0 1.8-1.2 3.6-3.8 4.3M166.4 21.5c-1 0-1.7.2-2.6 1.2-1 1.2-1.5 3.4-1.5 4.9 0 1.2.4 1.7 1.2 1.7 1 0 2.1-1 2.7-2.1l1.2-5.5c-.2-.1-.7-.2-1-.2m3 1.5l-.9 4.4c-.3 1.3-.2 1.9.4 2.5l-2 1.5c-.6-.5-.8-1.1-.8-1.8-.8 1.1-1.9 1.7-3.4 1.7-1.7 0-2.9-1.2-2.9-3.6 0-2.5.9-4.9 2.4-6.4 1.2-1.2 2.7-1.8 4.4-1.8 1.3 0 2.6.3 3.5.8-.2.8-.5 1.9-.7 2.7M181.2 23.1l-1.7 8h-2.4l1.6-7.4c.1-.5.2-.8.2-1.1 0-.6-.3-.9-.9-.9-.8 0-1.9.6-3.1 2.1l-1.5 7.3H171l1.6-7.7c.3-1.3.3-2.1 0-2.9l2.3-.9c.2.5.4 1.3.2 2.1 1.1-1.3 2.5-2 4-2 1.4 0 2.2.9 2.2 2.2 0 .3 0 .8-.1 1.2M189.1 24.8l3.4 6.2-2.7.3-3.1-6.5 4.6-5 2.6.4-4.8 4.6zm-1.3-6.1l-2.7 12.4h-2.4l2.6-12.4c.3-1.4.4-2.5.2-3.2l2.5-.8c.2.6.2 2-.2 4z"></path>              <!-- eslint-enable-->
              </svg>
            </a>
          </div>
          <div class="col-sm-4 col-4 divtitle">
              <span class="header__btn-back"> {{ $t("headers.title") }}</span>
          </div>
          <div class="col-sm-5 col-5">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 divoptions">
            <select class="header__select" :v-model="currentLanguage" @change="changeLanguageInStore">
            <option v-for="(language,idx) in currentCountryLanguages"
              :key="idx" :value="language.code"
              :selected="currentLanguage === language.code">{{language.name}}
            </option>
            </select>
              <button class="header-button btn btn--white submit-button" @click="goToEbanking">
                E-BANKING
              </button>
              </div>
            </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <main id="wrapper" class="global-wrap">
          <router-view/>
    </main>
    <footer class="footer">
      <div class="container">
        <div class="multi-color-line">
          <div class="line line_yellow"/>
          <div class="line line_crimson"/>
          <div class="line line_red"/>
          <div class="line line_green"/>
          <div class="line line_purple"/>
          <div class="line line_blue"/>
          </div>
      </div>
      <div class="container footer-content">
        <div class="row">
          <div class="col-sm-12 footer__rc">
            <ul class="footer-nav">
            <li class="footer-nav__item">
              <span class="version"> v1.0.10 </span>
            </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import config from '../config';

export default {
  name: 'app',
  created() {
    this.$store.commit('changeCurrentLocale', this.$route.params.languageCode);
    this.$store.commit('changeCurrentCountry', this.$route.params.countryCode);
    this.getDataForCountry();
    this.$router.beforeEach((to, from, next) => {
      document.title = to.meta.title;
      next();
    });
    // user must confirm page refresh to avoid losing progress
    window.addEventListener('beforeunload', (event) => {
      event.returnValue = '';
    });
  },
  mounted() {
    window.addEventListener('load', () => {
      this.domLoaded = true;
    });
  },
  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },
    currentCountryLanguages() {
      return this.$store.getters.currentCountryLanguages;
    },
    ebankingUrl() {
      return this.$store.getters.ebankingUrl;
    },
  },
  watch: {
    currentLanguage() {
      this.$i18n.locale = this.currentLanguage;
    },
  },
  methods: {
    goToEbanking() {
      window.open(this.ebankingUrl, '_blank');
    },
    changeLanguageInStore(e) {
      this.$store.commit('changeCurrentLocale', e.target.value);
      this.$router.push({ name: 'onboard', params: { countryCode: this.$store.state.currentCountry, languageCode: e.target.value } });
    },
    gethomelink() {
      if (this.$store.state.currentCountry === 'kos') {
        if (this.currentLanguage === 'en') return config.homeUrlkosen;
        if (this.currentLanguage === 'sq') return config.homeUrlkossq;
        if (this.currentLanguage === 'sr') return config.homeUrlkossr;
      }
      if (this.$store.state.currentCountry === 'mda') {
        if (this.currentLanguage === 'en') return config.homeUrlmdaen;
        if (this.currentLanguage === 'ru') return config.homeUrlmdaru;
        if (this.currentLanguage === 'ro') return config.homeUrlmdaro;
      }
      return config.homeUrl;
    },
    ...mapActions(['getDataForCountry']),
  },
  data() {
    return {
      homeUrl: config.homeUrlkosenl,
      domLoaded: false,
    };
  },
};
</script>

<style lang="scss">
  @import 'styles/core.sass';
</style>
